import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Divider, Popup, Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { imageConfig } from "../../../../config/config";

export default function CenterPage({
  coinList,
  tbhandle,
  use,
  setUse,
  coinPriceData,
  userInfo,
  addressList,
}) {
  const navigate = useNavigate();
  const [addrId, setAddrId] = useState(0);
  const [img, setImg] = useState("");
  const [num, setNum] = useState("");
  const { t: translate } = useTranslation();
  const [address, setAddress] = useState("");
  const [visible, setVisible] = useState(false);
  let cid = 0;

  // 点击回调提前处理
  const callBack = () => {
    if (!num) {
      return;
    }
    if (coinPriceData?.close != undefined && !coinPriceData?.close) {
      return;
    }
    if (!(address && Number(num) > 0)) {
      Toast.show({ content: translate(getText("请输入正确信息")) });
      return;
    }
    tbhandle({
      cid,
      num: Number(num),
      address,
      currenyName: use?.name?.toUpperCase(),
      currenyNum:
        `${Number(num) / Number(coinPriceData?.close)}` === "NaN"
          ? Number(num)
          : Number(num) / Number(coinPriceData?.close),
    });
    setTimeout(() => {
      setNum("");
      setAddress("");
    }, 500);
  };

  useEffect(() => {
    cid = coinList[0]?.id;
  });

  return (
    <div className="bg-neutral-900 min-h-screen w-full text-neutral-200 revert-style">
      <div className="max-w-lg mx-auto px-4 py-6 animate-fade-in">
        {/* 提现卡片 */}
        <div className="bg-neutral-800/80 rounded-xl p-5 mb-6 shadow-lg">
          {/* 币种信息 */}
          <div className="flex items-center gap-3 mb-5 border-b border-neutral-700 pb-4">
            <img
              src={imageConfig.baseImageUrl + use?.img}
              className="w-10 h-10 rounded-full"
              alt={use?.name}
            />
            <div className="text-lg font-medium text-white">
              {use?.name?.toUpperCase()} {translate(getText("提現"))}
            </div>
          </div>

          {/* 提币地址 */}
          <div className="mb-5">
            <label className="block text-sm text-neutral-300 mb-2">
              {translate(getText("提幣地址"))}
            </label>
            <div 
              className="bg-neutral-900/50 rounded-lg overflow-hidden flex items-center cursor-pointer hover:bg-neutral-800/60 transition-all"
              onClick={() => {
                setVisible(true);
              }}
            >
              <input
                style={{
                  pointerEvents: "none",
                }}
                className="w-full bg-transparent px-4 py-3 text-white focus:outline-none cursor-pointer"
                placeholder={translate(getText("請輸入提幣地址"))}
                value={address}
                readOnly
              />
            </div>
          </div>

          {/* 提币数量 */}
          <div className="mb-5">
            <label className="block text-sm text-neutral-300 mb-2">
              {translate(getText("提幣數量"))}(USDT)
            </label>
            <div className="bg-neutral-900/50 rounded-lg overflow-hidden flex items-center">
              <input
                type="number"
                className="w-full bg-transparent px-4 py-3 text-white focus:outline-none"
                placeholder={translate(getText("請輸入提幣數量"))}
                id="usdtmoney"
                name="usdtmoney"
                autoComplete="off"
                value={num}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setNum("");
                  }
                  if (/^[0-9]+(\.[0-9]{0,5})?$/.test(e.target.value)) {
                    setNum(e.target.value);
                  }
                }}
              />
            </div>
            <div className="mt-2 text-right">
              <span className="text-sm text-neutral-400">
                {translate(getText("可用:"))}
                {userInfo?.usdt} USDT
              </span>
            </div>
          </div>

          {/* 预计到账数量 */}
          <div className="mb-6 py-3 px-4 bg-neutral-900/50 rounded-lg text-sm">
            <div className="text-neutral-300">
              {translate(getText("預計到賬數量："))}
              {`${Number(num) / Number(coinPriceData?.close)}` === "NaN"
                ? num
                : (Number(num) / Number(coinPriceData?.close)).toFixed(6)}{" "}
              {use?.name?.toUpperCase()}
            </div>
          </div>

          {/* 提交按钮 */}
          <button
            className={`w-full bg-gradient-to-r from-violet-600 to-indigo-600 hover:opacity-90 text-white font-medium rounded-full py-3 px-6 transition-all duration-300 ${
              !num || !address ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => {
              callBack();
            }}
          >
            {translate(getText("提交"))}
          </button>
        </div>

        {/* 底部间距 */}
        <div className="h-20"></div>
      </div>

      {/* 地址选择弹窗 */}
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        onClose={() => {
          setVisible(false);
        }}
        bodyStyle={{ 
          height: "40vh", 
          overflowY: "scroll",
          background: "#1f1f23",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          padding: "16px" 
        }}
        className="revert-style"
      >
        <div className="text-lg font-medium text-white mb-4 text-center">
          {translate(getText("點擊選擇錢包地址"))}
        </div>
        {addressList.map((data, index) => (
          <div
            key={index}
            onClick={() => {
              setAddress(data.addr);
              setVisible(false);
            }}
          >
            <div className="py-3 cursor-pointer hover:bg-neutral-800/40 rounded-lg transition-all px-3">
              <div className="flex flex-col">
                <span className="text-white font-medium mb-1">
                  {`${data?.name.toUpperCase()}${
                    data.czline ? `-${data.czline}`.toUpperCase() : ""
                  }`}
                </span>
                <span className="text-neutral-400 text-sm break-all">
                  {data.addr}
                </span>
              </div>
            </div>
            {index < addressList.length - 1 && (
              <Divider style={{ borderColor: "#333" }} />
            )}
          </div>
        ))}
      </Popup>
    </div>
  );
}
